









































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import AButton from '@/components/common/AButton.vue';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'vue-feather-icons';
import { ConfirmAccountModel, IUser } from 'admiral-core';
import { AuthAction } from '@/store/AuthModule';
import { AuthApi } from '@/services/AuthApi';
import ConfirmAccountForm from '@/views/pages/auth/ConfirmAccountForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { mixins } from 'vue-class-component';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'confirm-account',
  components: { FormSubmit, ConfirmAccountForm, AButton, EyeIcon, EyeOffIcon, InfoIcon },
})
class ConfirmAccount extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  defaultModel(): ConfirmAccountModel {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      code: '',
    };
  }

  userToBeConfirmed: IUser | null = null;

  async mounted() {
    try {
      const result = await AuthApi.getConfirmationAccount(this.$route.params.code);
      this.userToBeConfirmed = { ...result.data };
      this.model.email = this.userToBeConfirmed.email;
    } catch (e) {
      this.errors = {
        code: [
          'Der Account konnte nicht aktiviert werden. Melde Dich bitte bei team@admiral-dashboard.de',
        ],
      };
    }
  }

  async handleConfirmation() {
    try {
      if (!this.userToBeConfirmed) {
        return;
      }
      this.$Progress.start();
      this.isLoading = true;

      await AuthApi.confirmAccount({
        code: this.$route.params.code,
        password: this.model.password,
        passwordConfirm: this.model.passwordConfirm,
        user: this.userToBeConfirmed,
      });
      await this.$store.dispatch(`AuthModule/${AuthAction.Login}`, {
        email: this.userToBeConfirmed?.email,
        password: this.model.password,
      });

      const text = 'Der Account wurde erfolgreich aktiviert.';

      if (this.user) {
        await this.fetchDataAfterLogin();

        this.$router.push({
          name: 'start',
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          params: { confirm: { code: 'success', text } },
        });
      }
      this.$Progress.finish();
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.addError(
        apiErrors['passwordisNotEmpty'] ||
          apiErrors['passwordminLength'] ||
          apiErrors['PasswordPolicy'],
        'password',
        'Bitte beachte, dass das Passwort mindestens 8 Zeichen, ein Sonderzeichen und eine Zahl beinhalten muss.',
      );

      this.addError(
        apiErrors['passwordConfirmisNotEmpty'] || apiErrors['passwordConfirmminLength'],
        'passwordConfirm',
        'Die Passwortbestätigung muss übereinstimmen.',
      );

      this.$toastr.e('Beim Bestätigen des Benutzerkontos ist etwas schief gelaufen.', 'Oops');

      this.$Progress.fail();
      throw e;
    } finally {
      this.isLoading = false;
    }
  }
}

export default ConfirmAccount;
